module.exports = __webpack_public_path__ + "img/P150T_weapon_125.199ebce8.png";